import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Measurement Frequency List with Query (for remote operations)
export const getMeasurementFrequencyListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_MEASUREMENT_FREQUENCIES}?${stringifyParams(
			params
		)}`
	);
};

// Get Measurement Frequency List
export const getMeasurementFrequencyList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_MEASUREMENT_FREQUENCIES}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Measurement Frequency
export const getMeasurementFrequency = measurement_frequency_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_MEASUREMENT_FREQUENCY}${measurement_frequency_id}`
	);
};

// Add New Measurement Frequency
export const addNewMeasurementFrequencyApi = measurement_frequency => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_MEASUREMENT_FREQUENCY}`,
		measurement_frequency
	);
};

// Update Measurement Frequency
export const updateMeasurementFrequencyApi = measurement_frequency => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_MEASUREMENT_FREQUENCY}${measurement_frequency._id}`,
		measurement_frequency
	);
};

// Delete Measurement Frequency
export const deleteMeasurementFrequencyApi = measurement_frequency_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_MEASUREMENT_FREQUENCY}${measurement_frequency_id}`
	);
};

// Check if Measurement Frequency Exists
export const checkMeasurementFrequencyExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_MEASUREMENT_FREQUENCY_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
